<template>
  <div class="main-menu menu-fixed menu-accordion menu-shadow" :class="[
    { 'expanded': expanded },
    skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
  ]" @mouseenter="updateMouseHovered(true)" @mouseleave="updateMouseHovered(false)">
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot name="header" :toggleVerticalMenuActive="toggleVerticalMenuActive" :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon">
        <ul class="nav navbar-nav flex-row">

          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link class="navbar-brand" to="/">
              <!-- <span class="brand-logo">
                <b-img class="logoimage1" :src="LogoImage1" alt="logo1" />
                <b-img class="logoimage2" :src="LogoImage2" alt="logo2" />
              </span> -->
              <span class="brand-logo" v-if="expanded">
                <b-img :src="appLogoImage" alt="Full-logo" />
              </span>
              <span class="brand-minilogo" v-else>
                <b-img :src="appMiniLogo" alt="Mini-logo" />
              </span>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon icon="XIcon" size="20" class="d-block d-xl-none" style="padding-right: 5px"
                @click="toggleVerticalMenuActive" />
              <feather-icon :icon="collapseTogglerIconFeather" size="20" class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed" />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="main-menu-content scroll-area" tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }">
      <div class="d-flex align-items-center justify-content-between search-container">
        <navigation-search :expanded="expanded" />
        <b-link
          v-if="isUserHasType(USER_TYPES.OWNER) || isUserHasType(USER_TYPES.BRANCH_ADMIN) || isUserHasType(USER_TYPES.KITCHEN_SUPERVISOR)"
          class="nav-link  modern-nav-toggle p-0" style="z-index: 1031; margin-right: 7px ">
          <div>
            <img
              :src="showShortcuts ? require('@/assets/images/icons/shortcuts/shortcuts.svg') : require('@/assets/images/icons/shortcuts/shortcuts-normal.svg')"
              alt="Icon" width="40" height="40" @click="toggleShortcuts">
          </div>
          <!--          <feather-icon-->
          <!--            icon="GridIcon"-->
          <!--            size="20"-->
          <!--            class="d-xl-block collapse-toggle-icon"-->
          <!--            @click="toggleShortcuts"-->
          <!--          />-->
        </b-link>
      </div>
      <vertical-nav-menu-items :items="navMenuItems" class="navigation navigation-main" />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import navMenuItems from '@/navigation/vertical'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'
import NavigationSearch from '@/@okmenu/components/inputs/NavigationSearch'
import PermissionMixin from '@/mixins/permission-mixin'

export default {
  components: {
    NavigationSearch,
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  directives: {
    Ripple,
  },
  mixins: [PermissionMixin],
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  computed: {
    expanded() {
      return !this.isVerticalMenuCollapsed || (this.isVerticalMenuCollapsed && this.isMouseHovered)
    },
    ...mapGetters({
      showShortcuts: 'navigation/showShortcuts',
    }),
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()
    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const {
      appName, appLogoImage, LogoImage1, LogoImage2, appMiniLogo,
    } = $themeConfig.app
    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
      LogoImage1,
      LogoImage2,
      appMiniLogo,
    }
  },
  methods: {
    toggleShortcuts() {
      if (this.showShortcuts) this.$router.go(-1)
      else this.$router.push(({ name: 'admin:shortcuts' }))
    },
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";

.search-container {
  z-index: 1032 !important;
}
</style>
